<template>
    <div>
        <device-searching-text v-if="hasAppAndHasFilterStoreText" :search-term="appFilterStoreText">
        </device-searching-text>

        <device-no-apps-found v-if="emptyFilteredApplicationsForStoreAndHasFilterStoreText"
                              :filter-text="appFilterStoreText">
        </device-no-apps-found>

        <div v-else-if="!hasApp && !appFilterStoreText.length" class="text-center">
            <div class="subtitle-2 mt-6 mb-2">
<!--                <v-img max-width="120" src="img/open-empty-box.jpg" class="w-25 text-center mx-auto"/>-->
                {{
                    $gettextInterpolate($gettext('Sorry, we do not have more applications for your %{device}'), {
                        device: chosenModel
                    })
                }}
            </div>
        </div>
    </div>
</template>

<script>
import {computed, toRef} from "vue";
import DeviceNoAppsFound from "@/components/blocks/DeviceNoAppsFound.vue";
import DeviceSearchingText from "@/components/blocks/DeviceSearchingText.vue";
import {usePhonesStore} from "@/stores/PhonesStore";
import {storeToRefs} from "pinia";

export default {
    name: 'AppStoreMessages',
    components: {DeviceSearchingText, DeviceNoAppsFound},
    props: {
        hasApp: {
            type: Boolean,
            required: true,
            default: false,
        },
        appFilterStoreText: {
            type: String,
            required: true,
            default: '',
        },
    },
    setup(props, context) {

        const appFilterStoreText = toRef(props, 'appFilterStoreText')
        let hasAppAndHasFilterStoreText = computed(() => (props.hasApp && appFilterStoreText.value.length > 0))
        let emptyFilteredApplicationsForStoreAndHasFilterStoreText = computed(() => (!props.hasApp && appFilterStoreText.value.length))

        const phonesStore = usePhonesStore()
        const {
            chosenModel,
        } = storeToRefs(phonesStore);

        return {
            chosenModel,
            hasAppAndHasFilterStoreText,
            emptyFilteredApplicationsForStoreAndHasFilterStoreText,
        }

    },
}
</script>
<style type="text/css">
.w-50 {
    width: 50%;
}

.w-25 {
    width: 25%;
}
</style>
